import {
  ArticlePage,
  getStaticProps,
  getStaticPaths,
} from '@public/CmsPage/ArticlePage'

export { getStaticProps, getStaticPaths }

export default ArticlePage
